import ApiBase from '../ApiBase';

/**
 * @classdesc Auth interactions
 */
class Auth extends ApiBase {
  /**
   * @method register
   * @param {object} data
   * @return {Promise<*>}
   */
  register = (data) => {
    return this.post('auth/register', data, 'register', 200, {
        headers: {
            "Content-Type": undefined
        }
    });
  };

  /**
   * @method verify
   * @param {string} userId
   * @param {string} token
   * @return {Promise<*>}
   */
  verify = (userId, token) => {
    return this.post('auth/verify', {
        id: userId,
        token,
    }, null, 200, {
        headers: {
            "Content-Type": undefined
        }
    });
  };

  /**
   * @method login
   * @param {string} email
   * @param {string} password
   * @return {Promise<*>}
   */
  login = (email, password) => {
    return this.post('auth/login', {
        email, password,
    }, 'login', 200, {
        headers: {
            "Content-Type": undefined
        }
    });
  };

  /**
   * @method forgotPassword
   * @param {string} email
   * @return {Promise<*>}
   */
  forgotPassword = (email) => {
    return this.post('auth/password/email', {
        email,
    }, null, 200, {
        headers: {
            "Content-Type": undefined
        }
    });
  };

  /**
   * @method resetPassword
   * @param {string} token
   * @param {string} email
   * @param {string} password
   * @param {string} passwordConfirmation
   * @return {Promise<*>}
   */
  resetPassword = (token, email, password, passwordConfirmation) => {
    return this.post('auth/password/reset', {
        token,
        email,
        password,
        password_confirmation: passwordConfirmation,
    }, null, 200, {
        headers: {
            "Content-Type": undefined
        }
    });
  };

  /**
   * @method logout
   * @return {Promise<*>}
   */
  logout = () => {
    return this.post('auth/logout', {}, 'logout', 200, {
        headers: {
            "Content-Type": undefined
        }
    });
  };

  /**
   * @method activate
   * @param {string} token
   * @param {object} data
   * @return {Promise<*>}
   */
  activate = (token, data) => {
    data = {
      ...data,
      password_confirmation: data.passwordConfirmation,
    };

    return this.post(`auth/activate/${token}`, data, 'activate', 200, {
        headers: {
            "Content-Type": undefined
        }
    });
  };

  /**
   * @method updateEmailRequest
   * @param {string} update
   * @param {string} user
   * @param {string} token
   * @return {Promise<*>}
   */
  updateEmailRequest = (update, user, token) => {
    return this.post(`auth/email/${update}/${user}/${token}`, {}, null, 200, {
        headers: {
            "Content-Type": undefined
        }
    });
  }
}

export default new Auth;
